<ng-template id="metadata" #metadata bsModal class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="Metadata" aria-hidden="true">
    <div class="modal-header bg-info text-white">
        <p class="modal-title">
            <strong class="mr-1">Sources</strong>
        </p>
        <button type="button" class="btn btn-sm btn-info" aria-label="Close" (click)="modalInstance.hide()">
            <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
    </div>
    <div class="modal-body p-0 pb-1">
        <div class="row row--content user-content">
            <div class="col">
                <ul class="list-group">
                    @for (metadataItem of metadatas; track metadataItem; let i = $index) {
                    <metadata-modal-item [metadataItem]="metadataItem"></metadata-modal-item>
                    }
                </ul>
            </div>
        </div>
    </div>
</ng-template>